import { cva, type VariantProps } from 'class-variance-authority';
import type { ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

const buttonVariants = cva(
  'inline-flex min-h-tap items-center justify-center gap-2 rounded-lg px-4 text-sm font-medium transition-colors select-none ' +
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        primary: 'bg-accent text-bg hover:opacity-90',
        secondary: 'border border-border bg-surface-2 text-fg hover:bg-surface',
        ghost: 'text-fg hover:bg-surface-2',
        /** Irreversible actions: always filled and labelled, never icon-only. */
        danger: 'bg-loss text-bg hover:opacity-90',
      },
      size: {
        md: '',
        icon: 'min-w-tap px-0',
        wide: 'w-full',
      },
    },
    defaultVariants: { variant: 'secondary', size: 'md' },
  },
);

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & VariantProps<typeof buttonVariants>;

export function Button({ className, variant, size, type = 'button', ...props }: ButtonProps) {
  return <button type={type} className={cn(buttonVariants({ variant, size }), className)} {...props} />;
}
